module.exports = __webpack_public_path__ + "static/media/b1.3ac5377d.jpg";